document.addEventListener('DOMContentLoaded', () => {
  const buttons = document.querySelectorAll('.cta_copy');

  buttons.forEach((btn) => {
    btn.addEventListener('click', async () => {
      // そのCTA内のテキストを優先して取得（なければフォールバック）
      const wrap = btn.closest('.box') || btn.parentElement;
      const textEl = wrap ? wrap.querySelector('.cta_copy_txt') : null;
      const textToCopy = (textEl?.textContent || 'Y3RFG4Y7FESW').trim();

      try {
        await navigator.clipboard.writeText(textToCopy);
        alert('コピーしました');
      } catch (e) {
        // フォールバック
        const ta = document.createElement('textarea');
        ta.value = textToCopy;
        ta.style.position = 'fixed';
        ta.style.left = '-9999px';
        document.body.appendChild(ta);
        ta.select();
        document.execCommand('copy');
        ta.remove();
        alert('コピーしました');
      }
    });
  });
});
